<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USR_APPL_STT_CD')"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectUserApplicationStateCode"
              v-model="queryData.userApplicationStateCode"
              codeId="COD_USR_APPL_STT"
              :defaultOption="'all'"
              :initialSelectedIndex="1"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APPL_DATE')"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="datePicker"
              v-model="rangeDate"
              :value="rangeDate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_APPL_USER')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldUserName"
              v-model="queryData.userName"
              maxlength="400"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridUserBasicApproval"
        :multiselect="true"
        :columns="columnUserBasicApproval"
        :dataset="'dsUserBasicApproval'"
        :showDisplayCountControl="true"
        :initial-pagesize="10"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:update="contextPageId"
          type="button"
          class="comm_btn_border"
          @click="onClickReject"
        >
          {{ $t('MSG_BTN_RJT') }}
        </sui-button>
        <sui-button
          v-permission:update="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onClickApprove"
        >
          {{ $t('MSG_BTN_APPR') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM', 'userApprovalDTM'];

export default {
  name: 'PGE_CMP_00018', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      queryData: {
        userName: '',
        userApplicationStateCode: '',
        firstRegistrationDTM: '',
        finalModificationDTM: '',
      },
      rangeDate: {
        from: utils.addDay(utils.now('YYYY-MM-DD'), -31),
        to: utils.now('YYYYMMDD'),
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsUserBasicApproval',
    type: 'local',
    datafields: [
      {
        name: 'userApplicationUid',
        type: 'string',
        map: 'userApplicationUid',
      },
      {
        name: 'userName',
        type: 'string',
        map: 'userName',
      },
      {
        name: 'userGlobalName',
        type: 'string',
        map: 'userGlobalName',
      },
      {
        name: 'companyCode',
        type: 'string',
        map: 'companyCode',
      },
      {
        name: 'companyName',
        type: 'string',
        map: 'companyName',
      },
      {
        name: 'email',
        type: 'string',
        map: 'email',
      },
      {
        name: 'firstRegistrationDTM',
        type: 'string',
        map: 'firstRegistrationDTM',
      },
      {
        name: 'userApplicationStateCode',
        type: 'string',
        map: 'userApplicationStateCode',
      },
      {
        name: 'userApprovalUserId',
        type: 'string',
        map: 'userApprovalUserId',
      },
      {
        name: 'userApprovalDTM',
        type: 'string',
        map: 'userApprovalDTM',
      },
      {
        name: 'apprUserLoginId',
        type: 'string',
        map: 'apprUserLoginId',
      },
      {
        name: 'apprUserName',
        type: 'string',
        map: 'apprUserName',
      },
      {
        name: 'apprUserGlobalName',
        type: 'string',
        map: 'apprUserGlobalName',
      },
      {
        name: 'apprDeptId',
        type: 'string',
        map: 'apprDeptId',
      },
      {
        name: 'apprDeptName',
        type: 'string',
        map: 'apprDeptName',
      },
      {
        name: 'apprDeptGlobalName',
        type: 'string',
        map: 'apprDeptGlobalName',
      },
      {
        name: 'apprDsplLangId',
        type: 'string',
        map: 'apprDsplLangId',
      },
    ],
  }],
  created() {
    this.columnUserBasicApproval = [
      {
        text: this.$t('MSG_TXT_APPL_USER'),
        datafield: 'userName',
      },
      {
        text: this.$t('MSG_TXT_COMPANY'),
        datafield: 'companyName',
      },
      {
        text: this.$t('MSG_TXT_EMAIL'),
        datafield: 'email',
      },
      {
        text: this.$t('MSG_TXT_APPL_DTM'),
        datafield: 'firstRegistrationDTM',
        width: '170px',
      },
      {
        text: this.$t('MSG_TXT_USR_APPL_STT_CD'),
        datafield: 'userApplicationStateCode',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {
            optionList: this.stateOptionList,
          }, this.dsUserBasicApproval, this.$refs.gridUserBasicApproval);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '100px',
      },
      {
        text: this.$t('MSG_TXT_APPR_RJT_USER'),
        datafield: 'userApprovalUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              userId: 'userApprovalUserId',
              userName: 'apprUserName',
              userGlobalName: 'apprUserGlobalName',
              departmentName: 'apprDeptName',
              departmentEnglishName: 'apprDeptGlobalName',
              displayLanguageId: 'apprDsplLangId',
              loginId: 'apprUserLoginId',
            },
          }, this.dsUserBasicApproval, this.$refs.gridUserBasicApproval);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '120px',
      },
      {
        text: this.$t('MSG_TXT_APPR_RJT_USER_DTM'),
        datafield: 'userApprovalDTM',
        width: '170px',
      },
    ];
    this.stateOptionList = [
      {
        type: 'waiting',
        key: '0',
        label: '신청',
      },
      {
        type: 'complete',
        key: '1',
        label: '승인',
      },
      {
        type: 'cancel',
        key: '2',
        label: '반려',
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onClickSearch();
      }
    },
    onClickSearch() {
      if (!this.validateDatePicker()) return false;
      const dataParams = {
        userName: this.queryData.userName,
        userApplicationStateCode: this.queryData.userApplicationStateCode,
        firstRegistrationDTM: utils.dateformatToServer(this.rangeDate.from),
        finalModificationDTM: utils.dateformatToServer(this.rangeDate.to).substr(0, 8).concat('235959'),
      };
      http.request(this.contextPageId, 'DTS_CMP_00065', {
        query: dataParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);
        this.dsUserBasicApproval.setRawData(res.data);
      });
    },
    onClickReset() {
      this.queryData.userName = '';
      this.$refs.codeSelectUserApplicationStateCode.reset();
      this.rangeDate = { from: utils.addDay(utils.now('YYYY-MM-DD'), -31), to: utils.now('YYYY-MM-DD') };
    },
    onClickReject() {
      const selectedRow = this.dsUserBasicApproval.getSelectedIndexes();
      const approveList = [];
      if (!this.validateApplyState(selectedRow)) {
        return false;
      }
      utils.forEach(selectedRow, index => {
        approveList.push({
          userApplicationUid: this.dsUserBasicApproval.data[index].userApplicationUid,
          loginId: this.dsUserBasicApproval.data[index].loginId,
          userApplicationStateCode: '2',
        });
      });
      utils.messageBox('confirm', this.$t('MSG_ALT_BAT_RJT_PRGS'), null, () => {
        http.request(this.contextPageId, 'DTS_CMP_00066', {
          data: approveList,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_REJECT_DATA'));
          this.onClickSearch();
        });
      });
      return true;
    },
    onClickApprove() {
      const selectedRow = this.dsUserBasicApproval.getSelectedIndexes();
      const approveList = [];
      if (!this.validateApplyState(selectedRow)) {
        return false;
      }
      utils.forEach(selectedRow, index => {
        approveList.push({
          userApplicationUid: this.dsUserBasicApproval.data[index].userApplicationUid,
          loginId: this.dsUserBasicApproval.data[index].loginId,
          userName: this.dsUserBasicApproval.data[index].userName,
          userGlobalName: this.dsUserBasicApproval.data[index].userGlobalName,
          email: this.dsUserBasicApproval.data[index].email,
          companyCode: this.dsUserBasicApproval.data[index].companyCode,
          userApplicationStateCode: '1',
          userPasswordValue: this.dsUserBasicApproval.data[index].userPasswordValue,
        });
      });
      utils.messageBox('confirm', this.$t('MSG_ALT_APPR'), null, () => {
        http.request(this.contextPageId, 'DTS_CMP_00066', {
          data: approveList,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_APPROVED'));
          this.onClickSearch();
        });
      });
      return true;
    },
    validateApplyState(selectedRow) {
      if (utils.isEmpty(selectedRow)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      }
      let result = true;
      utils.forEach(selectedRow, index => {
        if (this.dsUserBasicApproval.data[index].userApplicationStateCode !== '0') {
          utils.messageBox('warning', this.$t('MSG_ALT_REQ_STT_CHK'));
          result = false;
        }
      });
      return result;
    },
    validateDatePicker() {
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
</style>
